// ==========================================
// CURSE CART DRAWER - FINAL FIX (MINIMAL)
// ==========================================


if (typeof window.debounce !== 'function') {
  window.debounce = function (fn, wait = 300) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}

/** Sepet + hediye section önbelleği (ilk yüklemede prefetch; tıklanınca anında bas). */
window.__curseCartPrefetch = window.__curseCartPrefetch || {
  cart: null,
  sectionHtml: null,
  ts: 0,
  TTL: 20000,
  inflight: null,
  refresh() {
    if (this.inflight) return this.inflight;
    const run = Promise.all([
      fetch('/cart.js').then((r) => r.json()),
      fetch('/cart?section_id=cart-drawer').then((r) => r.text())
    ])
      .then(([cart, html]) => {
        this.cart = cart;
        this.sectionHtml = html;
        this.ts = Date.now();
        return this;
      })
      .finally(() => {
        this.inflight = null;
      });
    this.inflight = run;
    return run;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('cart-drawer')) return;
  const kick = () => window.__curseCartPrefetch.refresh().catch(() => {});
  if (typeof requestIdleCallback === 'function') requestIdleCallback(kick, { timeout: 1200 });
  else setTimeout(kick, 600);
});

/** Sepet kapanırken tier / hediye / FAB görünürlüğünü sıfırla */
window.closeCurseCartDrawerChrome = function closeCurseCartDrawerChrome(shell) {
  try {
    window.curseGiftSelector?.closeDrawer?.();
    window.curseGiftSelector?.hidePanel?.();
    window.curseGiftSelector?.syncGiftFab?.();
  } catch (e) {
    /* ignore */
  }

  document.getElementById('curse-gift-selector')?.setAttribute('data-active', 'false');

  const cartRoot = shell && shell.querySelector ? shell.querySelector('#CartDrawer') : null;
  const tierGiftScope = cartRoot || shell || document;
  if (tierGiftScope.querySelectorAll) {
    tierGiftScope
      .querySelectorAll('#CartDrawer-TierDiscount, #CartDrawer-TierDiscountFabCluster')
      .forEach((el) => {
        el.classList.remove('active', 'curse-gift-drawer--collapsed');
        el.style.setProperty('display', 'none', 'important');
      });
  }

  document.body.classList.remove(
    'overflow-hidden',
    'cart-drawer-open',
    'curse-gift-open',
    'curse-modal-open',
    'cs-menu-open'
  );
  document.documentElement.classList.remove('cart-drawer-open', 'overflow-hidden');
  document.body.style.removeProperty('--cs-scroll-lock-y');
  if (document.body.style.position === 'fixed') {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.height = '';
  }

  const colModal = document.getElementById('CurseColModal');
  if (colModal) colModal.classList.remove('is-open');

  document.querySelectorAll('.tier-upsell-modal').forEach((el) => {
    el.removeAttribute('open');
    el.classList.remove('is-open', 'active');
    el.style.display = 'none';
  });

  const giftWrap = document.getElementById('curse-cart-gift-fab-wrap');
  if (giftWrap) giftWrap.setAttribute('hidden', '');

  const tierFabCluster = shell && shell.querySelector('#CartDrawer-TierDiscountFabCluster');
  const giftFab = document.getElementById('curse-cart-gift-fab');
  if (tierFabCluster) {
    tierFabCluster.classList.remove('is-visible');
    tierFabCluster.setAttribute('hidden', '');
  }
  if (giftFab) giftFab.setAttribute('hidden', '');

  const rootDrawer = shell && shell.querySelector('#CartDrawer');
  const tier = rootDrawer && rootDrawer.querySelector('#CartDrawer-TierDiscount');
  if (tier) {
    tier.classList.add('tier-discount-bar--minimized', 'tier-discount-bar--user-hidden');
    tier.classList.remove('tier-discount-bar--collapsed');
    tier.setAttribute('aria-hidden', 'true');
    tier.style.setProperty('display', 'none', 'important');
  }
};

if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this._bindOverlay();
      this.setHeaderCartIconAccessibility();
      this._skeletonTimer = null;
      this._closeLockTimer = null;
    }

    _installCloseLayoutLock() {
      clearTimeout(this._closeLockTimer);
      let el = document.getElementById('curse-cart-close-lock');
      if (!el) {
        el = document.createElement('div');
        el.id = 'curse-cart-close-lock';
        el.setAttribute('aria-hidden', 'true');
        document.body.appendChild(el);
      }
      el.style.cssText =
        'position:fixed;inset:0;z-index:2147483000;background:transparent;pointer-events:auto;touch-action:none';
      const done = () => {
        clearTimeout(this._closeLockTimer);
        el.remove();
      };
      this._closeLockTimer = setTimeout(done, 420);
      this.addEventListener('transitionend', done, { once: true });
    }

    _bindOverlay() {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        const newOverlay = overlay.cloneNode(true);
        overlay.parentNode.replaceChild(newOverlay, overlay);
        newOverlay.addEventListener('click', this.close.bind(this));
      }
    }

    _getRootDrawer() {
      return this.querySelector('#CartDrawer') || this;
    }

    _curseAfterDrawerHtmlSwap() {
      const root = this.querySelector('#CartDrawer') || this;
      /* AJAX sonrası yeni hediye düğümü .loaded içermediğinde mobil panel görünmez — önce garanti hydrate */
      try {
        document.getElementById('curse-gift-selector')?.classList?.add('loaded');
      } catch (_) {
        /* ignore */
      }
      /* Tier küçült + X: idle’dan ÖNCE DOM ile senkron (swap sonrası bir kare FAB/tier kayması olmasın) */
      try {
        if (typeof window.restoreCurseTierMinimizedFromSession === 'function') {
          window.restoreCurseTierMinimizedFromSession(root);
        }
        if (typeof window.curseBindTierDismissButtons === 'function') {
          window.curseBindTierDismissButtons(root);
        }
      } catch (_) {
        /* ignore */
      }
      /* Hediye seçici DOM swap sonrası HEMEN güncellenmeli; idle gecikmesi kopmuş node üzerinde openPanels çalıştırıyordu. */
      try {
        if (typeof window.curseGiftSelector?.refreshDomRefs === 'function') {
          window.curseGiftSelector.refreshDomRefs();
        }
        window.curseGiftSelector?.scheduleCartSync?.(0);
      } catch (err) {
        console.warn('Curse gift DOM refresh:', err);
      }
      const run = () => {
        try {
          if (typeof window.curseBindTierDismissButtons === 'function') {
            window.curseBindTierDismissButtons(root);
          }
          if (typeof window.initTierDiscountBar === 'function') window.initTierDiscountBar(root);
          if (typeof window.syncTierDiscountAttributes === 'function') {
            window.syncTierDiscountAttributes(root);
          }
          if (typeof window.bindCurseTierDrawerInteractions === 'function') {
            window.bindCurseTierDrawerInteractions(this);
          }
          if (typeof window.restoreCurseTierMinimizedFromSession === 'function') {
            window.restoreCurseTierMinimizedFromSession(root);
          }
        } catch (err) {
          console.warn('Curse cart drawer chrome:', err);
        }
      };
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(run, { timeout: 480 });
      } else {
        window.setTimeout(run, 0);
      }
    }

    // 🔥 GÜNCELLENMİŞ HTML DEĞİŞTİRME MANTIĞI + GIFT SELECTOR PRESERVE
    _swapDrawerHTML(html) {
      if (!html) return;
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // 1. Yeni gelen içerikteki ana #CartDrawer'ı bul
      const newDrawerContent = doc.querySelector('#CartDrawer');
      
      // 2. Mevcut sayfadaki #CartDrawer'ı bul
      const currentDrawer = this.querySelector('#CartDrawer');

      if (currentDrawer && newDrawerContent) {
        const detachedGift = currentDrawer.querySelector('#curse-gift-selector');

        currentDrawer.innerHTML = newDrawerContent.innerHTML;

        const hasGift = !!currentDrawer.querySelector('#curse-gift-selector');
        if (!hasGift && detachedGift) {
          const overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
          const inner = currentDrawer.querySelector('.drawer__inner');
          if (overlay && inner) {
            inner.parentNode.insertBefore(detachedGift, inner);
          } else if (inner) {
            currentDrawer.insertBefore(detachedGift, inner);
          } else {
            currentDrawer.appendChild(detachedGift);
          }
        }
        
        // Class'ları da güncelle (dolu/boş durumu için)
        currentDrawer.className = newDrawerContent.className;
        
        // Dinleyicileri tekrar bağla
        this._bindOverlay();
        this._curseAfterDrawerHtmlSwap();
        if (this.classList.contains('active')) this._finishDrawerReveal();
      } else {
        // Eğer ID bulamazsa fallback olarak section'ı bas
        console.warn('CartDrawer ID bulunamadı, fallback çalışıyor.');
        this.innerHTML = newDrawerContent ? newDrawerContent.outerHTML : html;
        this._curseAfterDrawerHtmlSwap();
        if (this.classList.contains('active')) this._finishDrawerReveal();
      }
    }

    _finishDrawerReveal() {
      clearTimeout(this._skeletonTimer);
      this.classList.remove('cart-drawer--show-skeleton');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.remove('cart-drawer--layout-pending');
          this.classList.add('cart-drawer--content-ready');
        });
      });
    }

    applyPrefetchedCart(cart, html) {
      if (cart && typeof cart.item_count === 'number') this.updateHeaderBubble(cart.item_count);
      if (html) this._swapDrawerHTML(html);
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;

      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');

      const newCartLink = cartLink.cloneNode(true);
      cartLink.parentNode.replaceChild(newCartLink, cartLink);

      newCartLink.addEventListener('click', async (event) => {
        event.preventDefault();
        this.open(newCartLink);
        const pf = window.__curseCartPrefetch;
        const fresh =
          pf &&
          pf.sectionHtml &&
          pf.cart &&
          typeof pf.ts === 'number' &&
          Date.now() - pf.ts < pf.TTL;
        if (fresh) {
          this.applyPrefetchedCart(pf.cart, pf.sectionHtml);
          this._finishDrawerReveal();
          pf.refresh().catch(() => {});
        } else {
          await this.updateCartContent();
        }
      });
    }

    open(triggeredBy) {
      if (typeof window.__closeCsMobileMenu === 'function') {
        window.__closeCsMobileMenu();
      }

      if (triggeredBy) this.setActiveElement(triggeredBy);

      clearTimeout(this._skeletonTimer);
      this.classList.remove('cart-drawer--show-skeleton');

      this.classList.add('cart-drawer--layout-pending');
      this.classList.remove('cart-drawer--content-ready');

      this._skeletonTimer = setTimeout(() => {
        if (this.classList.contains('cart-drawer--layout-pending')) {
          this.classList.add('cart-drawer--show-skeleton');
        }
      }, 100);

      const rootDrawer = this._getRootDrawer();
      if (rootDrawer) rootDrawer.classList.remove('hidden');

      const tier = rootDrawer && rootDrawer.querySelector('#CartDrawer-TierDiscount');
      if (tier) {
        tier.style.removeProperty('display');
        tier.classList.remove(
          'tier-discount-bar--user-hidden',
          'tier-discount-bar--collapsed',
          'tier-discount-bar--minimized'
        );
        tier.removeAttribute('aria-hidden');
      }

      const cluster = this.querySelector('#CartDrawer-TierDiscountFabCluster');
      if (cluster) {
        cluster.classList.remove('is-visible');
        cluster.setAttribute('hidden', '');
        if (typeof window.curseTierClusterClearInline === 'function') {
          window.curseTierClusterClearInline(cluster);
        }
      }

      if (typeof window.restoreCurseTierMinimizedFromSession === 'function') {
        window.restoreCurseTierMinimizedFromSession(rootDrawer);
      }

      this.classList.add('animate', 'active');

      this.addEventListener(
        'transitionend',
        () => {
          const drawer = this._getRootDrawer();
          const focusElement = drawer.querySelector('.drawer__close') || drawer.querySelector('h2');
          if (focusElement) focusElement.focus();
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden', 'cart-drawer-open');
      document.documentElement.classList.add('cart-drawer-open');
      if (typeof window.curseSyncCartDrawerOpenClass === 'function') {
        window.curseSyncCartDrawerOpenClass();
      }
    }

    close() {
      if (typeof window.closeCurseCartDrawerChrome === 'function') {
        window.closeCurseCartDrawerChrome(this);
      }

      this._installCloseLayoutLock();

      clearTimeout(this._skeletonTimer);
      this.classList.remove('cart-drawer--show-skeleton');

      this.classList.remove(
        'active',
        'animate',
        'cart-drawer--layout-pending',
        'cart-drawer--content-ready'
      );
      document.body.classList.remove('overflow-hidden', 'cart-drawer-open');
      if (this.activeElement) this.activeElement.focus();
    }

    async updateCartContent() {
      try {
        const [cartRes, sectionRes] = await Promise.all([
          fetch('/cart.js'),
          fetch('/cart?section_id=cart-drawer')
        ]);

        const cart = await cartRes.json();
        this.updateHeaderBubble(cart.item_count);

        const itemsHtml = await sectionRes.text();
        const pf = window.__curseCartPrefetch;
        if (pf) {
          pf.cart = cart;
          pf.sectionHtml = itemsHtml;
          pf.ts = Date.now();
        }
        this._swapDrawerHTML(itemsHtml);
      } catch (error) {
        console.error('❌ Cart update hatası:', error);
      } finally {
        if (this.classList.contains('active')) this._finishDrawerReveal();
      }
    }

    updateHeaderBubble(count) {
      const cartBubble = document.querySelector('#cart-icon-bubble');
      if (!cartBubble) return;

      const bubbleEl =
        cartBubble.querySelector('.cs-cart-count-bubble') ||
        cartBubble.querySelector('.cart-count-bubble');
      const countSpan =
        cartBubble.querySelector('.icon-count') ||
        cartBubble.querySelector('.cart-count-bubble span[aria-hidden="true"]') ||
        cartBubble.querySelector('span[aria-hidden="true"]');

      const displayCount = count >= 100 ? '99+' : String(count);

      if (countSpan) {
        countSpan.textContent = displayCount;
      }

      if (count === 0) {
        cartBubble.classList.add('hidden-count');
        if (bubbleEl) bubbleEl.hidden = true;
      } else {
        cartBubble.classList.remove('hidden-count');
        if (bubbleEl) {
          bubbleEl.hidden = false;
          bubbleEl.removeAttribute('hidden');
        }
      }
    }

    renderContents(parsedState) {
      const sections = parsedState ? parsedState.sections : null;
      const itemCount = parsedState ? parsedState.item_count : null;

      if (typeof itemCount === 'number') this.updateHeaderBubble(itemCount);

      if (!sections) {
        this.updateCartContent();
        /* Sepet çekmece zaten açıksa yeniden open() çağırma — gereksiz animasyon/tier sıfırlama */
        if (!this.classList.contains('active')) this.open();
        return;
      }

      const drawerAlreadyActive = this.classList.contains('active');
      if (!drawerAlreadyActive) this.open();

      if (sections['cart-drawer']) {
        this._swapDrawerHTML(sections['cart-drawer']);
      } else if (this.classList.contains('active')) {
        this._finishDrawerReveal();
      }

      if (sections['cart-icon-bubble']) {
        const bubbleHost = document.querySelector('#cart-icon-bubble');
        if (bubbleHost) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = sections['cart-icon-bubble'];
          const newContent =
            tempDiv.querySelector('#cart-icon-bubble') || tempDiv;
          bubbleHost.innerHTML = newContent.innerHTML;
        }
      }

      queueMicrotask(() => {
        try {
          if (typeof window.curseGiftSelector !== 'undefined' && typeof window.curseGiftSelector.scheduleCartSync === 'function') {
            window.curseGiftSelector.scheduleCartSync(0);
          }
        } catch (e) {
          /* ignore */
        }
      });
    }

    getSectionsToRender() {
      return [
        { id: 'cart-drawer', section: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
      ];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

window.openCurseCartDrawer = function openCurseCartDrawer(triggerEl) {
  const d = document.querySelector('cart-drawer');
  if (!d || typeof d.open !== 'function') return;
  d.open(triggerEl || undefined);
  const pf = window.__curseCartPrefetch;
  const fresh =
    pf &&
    pf.sectionHtml &&
    pf.cart &&
    typeof pf.ts === 'number' &&
    Date.now() - pf.ts < pf.TTL;
  if (fresh) {
    d.applyPrefetchedCart(pf.cart, pf.sectionHtml);
    d._finishDrawerReveal();
    pf.refresh().catch(() => {});
  } else {
    d.updateCartContent();
  }
};


// ========== CART DRAWER ITEMS ==========

if (!customElements.get('cart-drawer-items')) {
  customElements.define(
    'cart-drawer-items',
    class CartDrawerItems extends HTMLElement {
      constructor() {
        super();

        // 🔥 SADECE CHANGE EVENTİ: Shopify +/− butonları input değerini değiştirir,
        // biz de sadece değişimi yakalayıp /cart/change.js çağırırız.
        this.addEventListener(
          'change',
          window.debounce((e) => {
            const input = e.target.closest('.quantity__input');
            if (!input) return;
            this.onChange(input);
          }, 300)
        );
      }

      onChange(input) {
        this.updateQuantity(input.dataset.index, input.value);
      }

      updateQuantity(line, quantity) {
        const lineItem =
          document.getElementById(`CartDrawer-Item-${line}`) || this;
        lineItem.classList.add('loading');

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            line,
            quantity,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
          .then((res) => res.json())
          .then((state) => {
            const drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.renderContents(state);
          })
          .catch(console.error)
          .finally(() => lineItem.classList.remove('loading'));
      }
    }
  );
}


// ========== CART REMOVE BUTTON ==========

if (!customElements.get('cart-remove-button')) {
  customElements.define(
    'cart-remove-button',
    class CartRemoveButton extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          event.preventDefault();
          const cartItems = this.closest('cart-drawer-items');
          if (cartItems) cartItems.updateQuantity(this.dataset.index, 0);
        });
      }
    }
  );
}


// ========== CURSE QUICK ADD (CARD BUTONU → AROMA POP-UP) ==========
// NOT: Shopify quick-add-modal (#QuickAdd-xxx) DOM'da render edilmiyor.
// Bu yüzden Curse popup (__openCurseQuickAdd) kullanıyoruz.

document.addEventListener(
  'click',
  function (e) {
    const btn = e.target.closest('.curse-add-btn');
    if (!btn) return;

    const card = btn.closest('.card, .product-card');
    if (!card) return;

    // Varyantlı ürün (Aroma Seç / Kapsül Seç vb.) → Curse popup aç
    const productUrl = btn.dataset.productUrl || card.dataset.productUrl;
    const modalBtn = card.querySelector('modal-opener .quick-add__submit');
    if (modalBtn && productUrl) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (typeof window.__openCurseQuickAdd === 'function') {
        window.__openCurseQuickAdd(productUrl);
      } else {
        modalBtn.click(); // Fallback
      }
    }
  },
  true
);


// ===================================================
// 🔥 CURSE QUICK ADD (AGRESİF KİLİT MEKANİZMASI VE KESİN KORUMA)
// ===================================================

document.addEventListener('click', async (event) => {
  const btn = event.target.closest('.curse-add-btn');
  if (!btn) return;

  // 🔥 Eğer varyantlı ürünse (Aroma Seç vb.) → Curse popup aç
  const card = btn.closest('.card, .product-card');
  if (card) {
    const modalOpenerBtn = card.querySelector('modal-opener .quick-add__submit');
    const productUrl = btn.dataset.productUrl || card.dataset.productUrl;
    if (modalOpenerBtn && productUrl && typeof window.__openCurseQuickAdd === 'function') {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.__openCurseQuickAdd(productUrl);
      return;
    }
  }

  // 1. KRİTİK KİLİT KONTROLÜ
  if (btn.hasAttribute('data-is-adding')) {
    console.log('⛔ İşlem zaten devam ediyor, çift tıklama engellendi.');
    return;
  }

  // 2. KİLİT
  btn.setAttribute('data-is-adding', 'true');

  // 3. EVENT KESME
  event.stopImmediatePropagation();

  // 4. FORM KONTROLÜ: product-form içindeyse bizim scripti atla
  if (btn.closest('product-form') || btn.closest('form[action*="/cart/add"]')) {
    btn.removeAttribute('data-is-adding');
    return;
  }

  event.preventDefault();

  const variantId =
    btn.dataset.variantId || btn.getAttribute('data-variant-id');
  const productUrl =
    btn.dataset.productUrl || btn.getAttribute('data-product-url');

  if (!variantId && productUrl) {
    btn.removeAttribute('data-is-adding');
    window.location.href = productUrl;
    return;
  }

  try {
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');

    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble']
      })
    });

    const state = await addRes.json();

    if (state.status === 422) {
      alert(state.description);
      return;
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.renderContents(state);
    } else {
      window.location.reload();
    }
  } catch (err) {
    console.error('Hata:', err);
  } finally {
    btn.removeAttribute('data-is-adding');
    btn.removeAttribute('aria-disabled');
    btn.classList.remove('loading');
  }
});


// ===========================================
// CURSE: QUICK ADD FORM ZORUNLU ENGELLEYİCİ
// ===========================================

// 1. Tek Varyantlı ürünlerin gizli formlarını seçin
const quickAddForms = document.querySelectorAll(
  '.quick-add:not(.quick-add-modal) form[data-type="add-to-cart-form"]'
);

// 2. Her bir forma bir event listener ekleyin
quickAddForms.forEach((form) => {
  if (form) {
    form.addEventListener(
      'submit',
      function (evt) {
        // ⛔ Zinciri Mutlak KOPAR
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        console.warn(
          'Curse Guard: Gizli Quick Add form submit işlemi engellendi. Bu, çift ürün eklemeyi engeller.'
        );
      },
      true
    ); // UseCapture: Yakalama aşamasında olayı durdurmak için 'true'
  }
});

/** cart-drawer-open: tüm açılış yollarında (class/attribute) senkron */
window.curseSyncCartDrawerOpenClass = function curseSyncCartDrawerOpenClass() {
  var drawer = document.querySelector('cart-drawer.curse-cart-drawer-v2, cart-drawer');
  if (!drawer) return;
  var open = drawer.classList.contains('active');
  document.body.classList.toggle('cart-drawer-open', open);
  document.documentElement.classList.toggle('cart-drawer-open', open);
  if (open) {
    document.body.classList.add('overflow-hidden');
  }
};

(function curseCartDrawerOpenObserver() {
  function boot() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    window.curseSyncCartDrawerOpenClass();
    var obs = new MutationObserver(function () {
      window.curseSyncCartDrawerOpenClass();
    });
    obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

document.addEventListener(
  'click',
  function (e) {
    if (window.__CURSE_CART_PAGE__) return;
    var btn = e.target.closest('#CartDrawer-Checkout');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    var cartUrl =
      btn.getAttribute('data-cart-url') ||
      (window.routes && window.routes.cart_url) ||
      '/cart';
    if (typeof window.hideCurseLoading === 'function') window.hideCurseLoading();
    window.location.assign(cartUrl);
  },
  true
);
